import * as React from "react"
import {
  Box,
  Flex,
  Heading,
  Text,
  Stack,
  Container,
  Avatar,
  useColorModeValue,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react';
import Slider from 'react-slick';
import {testimonials} from '../constants';

// Settings for the slider
const settings = {
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const TestimonialTrio = ({ testimonial }) => {
  return (
    <div>
      <SimpleGrid columns={{lg: 1, xl: 3}} spacing={4}>
        {testimonial.map((item) => {
        return (
          <Testimonial key={item.title}>
              <TestimonialContent>
                <TestimonialHeading>{item.title}</TestimonialHeading>
                <TestimonialText>{item.text}</TestimonialText>
              </TestimonialContent>
              <TestimonialAvatar name={item.name}/>
            </Testimonial>
          );
        })}
      </SimpleGrid>
    </div>);
};

const Testimonial = ({ children }) => {
  return <Flex direction='column'>{children}</Flex>;
};

const TestimonialContent = ({ children }) => {
  return (
    <Stack
      bg={useColorModeValue('white', 'gray.800')}
      boxShadow={'lg'}
      p={8}
      rounded={'xl'}
      align={'center'}
      pos={'relative'}
      flex={1}
      _after={{
        content: `""`,
        w: 0,
        h: 0,
        borderLeft: 'solid transparent',
        borderLeftWidth: 16,
        borderRight: 'solid transparent',
        borderRightWidth: 16,
        borderTop: 'solid',
        borderTopWidth: 16,
        borderTopColor: useColorModeValue('white', 'gray.800'),
        pos: 'absolute',
        bottom: '-16px',
        left: '50%',
        transform: 'translateX(-50%)',
      }}>
      {children}
    </Stack>
  );
};

const TestimonialHeading = ({ children }) => {
  return (
    <Heading className={'testimonial__heading'} as={'h3'} fontSize={'xl'} textAlign={'center'}>
      {children}
    </Heading>
  );
};

const TestimonialText = ({ children }) => {
  return (
    <Text
      textAlign={'center'}
      fontSize={'md'}
      marginTop={'15px !important'}>
      {children}
    </Text>
  );
};

const TestimonialAvatar = ({
  src,
  name,
}) => {
  return (
    <Flex align={'center'} mt={8} direction={'column'}>
      <Avatar src={src} name={name} color='white' alt={name} mb={2} bg='#7B4B94' />
      <Stack spacing={-1} align={'center'}>
        <Text
          fontFamily={'PoppinsMedium, sans-serif, serif'}
          fontWeight='normal'>
          {name}
        </Text>
      </Stack>
    </Flex>
  );
};

const TestimonialSection = () => {

  const useSlider = useBreakpointValue({base: false, md: true});

  return (
    <Box>
      {/* CSS files for react-slick */}
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <Container maxW={'7xl'} as={Stack} spacing={12}>
        <Stack spacing={0} align={'center'}>
          <Heading>Testimonials</Heading>
          <Text p='10px' fontSize='lg'>See what others are saying about us.</Text>
        </Stack>
        <Stack
          direction={{ base: 'column', xl: 'row' }}
          spacing={{ base: 10, md: 4, lg: 10 }}>
          {
            useSlider ? 
              <Slider {...settings} style={{width: '100%'}}>
                {testimonials.map((testimonial, index) => (
                  <TestimonialTrio testimonial={testimonial} key={`testimonial_trio_${index}`}></TestimonialTrio>
                ))}
              </Slider>
            :
              <TestimonialTrio testimonial={testimonials[0]}></TestimonialTrio>
          }
        </Stack>
      </Container>
    </Box>
  );
}

export default TestimonialSection;